function getSizeMapping(name) {
  if (!name) {
    return;
  }

  const sizeMappingConfig = window.mediaPressAdsConfig.gptSizeMappings[name];

  if (!sizeMappingConfig) {
    return;
  }

  const sizeMapping = window.googletag.sizeMapping();

  sizeMappingConfig.forEach((size) => {
    sizeMapping.addSize(size.viewPortSize, size.sizes);
  });

  return sizeMapping.build();
}

/**
 * Define a single ad slot.
 *
 * @param {string} uniqueId The unique slot ID.
 * @param {Object} config   The configuration for the slot.
 * @param {string} slotId   The universal slot ID.
 *
 * @return {void} Returns nothing but will set the ad slot on the window.
 */
function defineAdSlot(uniqueId, config, slotId) {
  if (!window.googletag) {
    return;
  }

  if (!window.mediaPressAdsSlots) {
    window.mediaPressAdsSlots = {};
  }

  if (window.mediaPressAdsSlots[uniqueId]) {
    return;
  }

  const slot = window.googletag
    .defineSlot(config.adUnitPath, config.sizes, uniqueId)
    .setCollapseEmptyDiv(true, true);

  const sizeMapping = getSizeMapping(slotId);

  if (sizeMapping) {
    slot.defineSizeMapping(sizeMapping);
  }

  if (config.targeting) {
    Object.entries(config.targeting).forEach(([key, value]) => {
      window.googletag.pubads().setTargeting(key, value);
    });
  }

  slot.addService(window.googletag.pubads());

  window.dispatchEvent(new CustomEvent('mediaPressAdsSlotDefined', { detail: { slot } }));

  window.mediaPressAdsSlots[uniqueId] = slot;
}

export { getSizeMapping, defineAdSlot };
